var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { EntityCard, EntityCardDefaultProps } from './entity-card';
import { FileAssetMeta } from './file-asset-meta';
var cls = classNames('file-asset-card');
export var FileAssetCardDefaultProps = __assign({}, EntityCardDefaultProps);
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var MetaStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled(EntityCard)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Meta: styled(FileAssetMeta)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), MetaStyles)
};
export var FileAssetCard = function (props) {
  var _a, _b;
  var className = props.className,
    entity = props.entity,
    cardProps = __rest(props, ["className", "entity"]);
  // not sure where this was needed, but may need a proper fix somewhere 
  // const url = file.url || "/pdf";
  return React.createElement(My.Container, __assign({}, cardProps, {
    className: cls.name(className),
    entity: __assign(__assign({}, entity), {
      url: (_b = (_a = entity === null || entity === void 0 ? void 0 : entity.file) === null || _a === void 0 ? void 0 : _a.url) === null || _b === void 0 ? void 0 : _b.replace(/upload\//, 'upload/fl_attachment/')
    }),
    meta: React.createElement(My.Meta, {
      entity: entity
    })
  }));
};
FileAssetCard.defaultProps = FileAssetCardDefaultProps;
FileAssetCard.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;